import React, { useEffect, useState } from 'react'
import { useSelector } from "src/stateManagement/redux";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Grid from "@mui/material/Grid2";
import moment from "moment";

export interface ITableProps {
    dataToTable: any[],
    setdataToTable: any,
    filteredData: any[],
    filters: any[]
}


const WaterTest = ({ dataToTable, setdataToTable, filteredData, filters }: ITableProps) => {

    const { waterTests } = useSelector((state) => state.location);

    const [dataColumns, setDataColumns] = useState<GridColDef[]>([
        { field: 'samplingDate', headerName: 'Fecha de Muestra', minWidth: 100, flex: 1 },
        { field: 'receptionDate', headerName: 'Fecha de Recepcion', minWidth: 100, flex: 1 },
        { field: 'freeWaterPercentage', headerName: '% Agua Libre', minWidth: 100, flex: 1 },
        { field: 'emulsionPercentage', headerName: '% Emulsion', minWidth: 100, flex: 1 },
        { field: 'emulsifiedWaterPercentage', headerName: '% Agua Emulsionada', minWidth: 100, flex: 1 },
        { field: 'totalWaterPercentage', headerName: '% Agua Total ', minWidth: 100, flex: 1 },
        { field: 'sedimentPercentage', headerName: '% Sedimentos', minWidth: 100, flex: 1 },
        { field: 'observations', headerName: 'Observaciones', minWidth: 100, flex: 1 },
    ])

    const paginationModel = { page: 0, pageSize: 10 };

    useEffect(() => {
        const datToTable: any[] = []

        let sortActivities: any[] = [...waterTests].sort((a: any, b: any) => new Date(b.samplingDate).getTime() - new Date(a.samplingDate).getTime());

        for (const filter of filters) {
            const filterData = filteredData.find(f => f.name === filter.name);
            if (filterData) {
                if (filterData.action === 'greater') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] > filterData.value);
                } else if (filterData.action === 'less') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] < filterData.value);
                } else if (filterData.action === 'equal') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] === filterData.value);
                } else if (filterData.action === 'different') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] !== filterData.value);
                } else if (filterData.action === 'dissable') {
                    sortActivities = sortActivities || [];
                } else if (filterData.action === 'include' && filterData.value.length > 0) {
                    sortActivities = sortActivities.filter((x) => filterData.value.includes(x[filter.field]));
                } else if (filterData.action === 'equalAfter') {
                    sortActivities = sortActivities.filter((x) => {
                        const locationDate = moment(x.samplingDate);
                        return locationDate.isSameOrAfter(filterData.value, 'day')
                    });
                } else if (filterData.action === 'equalBefore') {
                    sortActivities = sortActivities.filter((x) => {
                        const locationDate = moment(x.samplingDate)
                        return locationDate.isSameOrBefore(filterData.value, 'day')
                    });
                }
            }
        }

        for (const act of sortActivities) {
            const data:any = {
                id: act.id,
                samplingDate: act.samplingDate,
                receptionDate: act.receptionDate,
                freeWaterPercentage: act.freeWaterPercentage,
            }


            const dateField= ['samplingDate','receptionDate']

            for (const field of dateField) {
                if (act[field]) {
                    try {
                        data[field] = moment(act[field]).format('DD/MM/YYYY')
                    } catch (error) {
                        
                    }
                }
            }

            const doubleField = ['freeWaterPercentage','emulsionPercentage','emulsifiedWaterPercentage','totalWaterPercentage','sedimentPercentage']

            for (const field of doubleField) {
                if (act[field]) {
                    try {
                        data[field] = parseFloat(act[field])
                    } catch (error) {
                        
                    }
                }
            }

            const stringField = ['observations']
            for (const field of stringField) {
                if (act[field]) {
                    try {
                        data[field] = act[field]
                    } catch (error) {
                    }
                }
            }

            datToTable.push(data)
        }

        setdataToTable(datToTable)

    }, [waterTests,filters])


    return (
        <Grid className="table-container">
            <DataGrid
                rows={dataToTable}
                columns={dataColumns}
                initialState={{
                    pagination: { paginationModel }
                }}
                pageSizeOptions={[10, 20, 50, 100]}
                checkboxSelection={false}
                sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: "#316EBC",
                        color: "#fff",
                        fontWeight: "bold",
                    },
                }}
                getRowId={(row) => row.id}
            />
        </Grid>
    )
}

export default WaterTest